import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'

@Component({
  selector: 'ddc-no-access',
  templateUrl: './ddc-no-access.component.html',
  styleUrls: ['./ddc-no-access.component.scss'],
  imports: [AngularMaterialsModules, CommonModule, RouterModule],
})
export class DdcNoAccessComponent {}
